import React, {FC} from 'react';
import copy from 'copy-to-clipboard';

interface Props {
  label: string;
  className?: string;
  text: string;
}

const TextGenerateResultItem: FC<Props> = ({className, text, label}) => {

  const handleCopy = () => {
    copy(text)
  }

  return (
    <div className={`text-generate-result-item ${className || ''}`}>
      <div className="text-medium-14 mb-2 text-muted">{label}</div>
      <div className="text-generate-result-text-wrap">
        <div className="text-generate-result-text">{text}</div>
        <div className="circle-btn copy" onClick={handleCopy}/>
      </div>
    </div>
  );
}

export default TextGenerateResultItem;